import http from "../http-common";

class FracttalService {

    getDocumentos(data) {
        return http.post("/fracttal/documento",data);
    }
}

export default new FracttalService();